import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, AlertCircle, ArrowRight } from "lucide-react";

/**
 * Payment result page for Moneris Checkout.
 * The backend Receipt API already verified the transaction before the app
 * navigates here with `reference` (+ optional `txn`) query params.
 */
export default function PaymentSuccess() {
    const [params] = useSearchParams();
    const reference = params.get("reference");
    const txn = params.get("txn");
    const ok = Boolean(reference);

    return (
        <div className="section" data-testid="payment-success-page">
            <div className="container-atm">
                <div className="card-soft mx-auto max-w-2xl p-10 text-center">
                    {ok ? (
                        <>
                            <span className="mx-auto inline-flex rounded-full bg-emerald-50 p-3 text-emerald-600">
                                <CheckCircle2 size={32} />
                            </span>
                            <h1 className="mt-6 text-3xl font-semibold">
                                Payment received. Thank you.
                            </h1>
                            <p className="mt-3 text-[15px] text-[#475569]">
                                Your booking is confirmed. We will follow up with the next step.
                            </p>
                            <div className="mt-8 rounded-2xl bg-[#F9F8F6] p-5">
                                <p className="text-xs font-semibold uppercase tracking-widest text-[#0E2A47]/60">
                                    Reference
                                </p>
                                <p
                                    className="mt-1 font-display text-2xl font-semibold text-[#F26B1F]"
                                    data-testid="payment-reference"
                                >
                                    {reference}
                                </p>
                                {txn && (
                                    <p className="mt-2 text-xs text-[#475569]" data-testid="payment-txn">
                                        Moneris transaction #{txn}
                                    </p>
                                )}
                            </div>
                            <p className="mt-4 text-sm text-[#475569]" data-testid="payment-meet-note">
                                If your service is a consultation, a Google Calendar invite
                                with your Google Meet link will arrive by email shortly.
                            </p>
                            <Link to="/" className="btn-secondary mt-8 inline-flex">
                                Back to home <ArrowRight size={16} />
                            </Link>
                        </>
                    ) : (
                        <>
                            <span className="mx-auto inline-flex rounded-full bg-orange-50 p-3 text-[#F26B1F]">
                                <AlertCircle size={32} />
                            </span>
                            <h1 className="mt-6 text-3xl font-semibold">Something went wrong</h1>
                            <p className="mt-3 text-[15px] text-[#475569]">
                                We couldn&apos;t find your payment reference. If you were charged,
                                contact us and we&apos;ll sort it out — your booking is saved.
                            </p>
                            <Link to="/book" className="btn-primary mt-8 inline-flex">
                                Try Again <ArrowRight size={16} />
                            </Link>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}
